import { storeToRefs } from "pinia";
import { useCAdsetsStore } from "@stores/cAdsets";
export const useCAdsetsFilters = () => {
  const cAdsetsStore = useCAdsetsStore();
  const { cCampaignStatusFilter, cAdsetsStatusFilter, cAdsetsGenderFilter, cAdsetsSearchQuery } =
    storeToRefs(cAdsetsStore);

  const updateFilter = async (filter, { filterValue, checkboxValue }) => {
    if (!checkboxValue) {
      const index = filter.value.indexOf(filterValue);
      if (index !== -1) filter.value.splice(index, 1);
    } else {
      filter.value.push(filterValue);
    }
  };
  const updateCCampaignStatusFilter = (newValue) => updateFilter(cCampaignStatusFilter, newValue);
  const updateCAdsetsStatusFilter = (newValue) => updateFilter(cAdsetsStatusFilter, newValue);
  const updateCAdsetsGenderFilter = (newValue) => updateFilter(cAdsetsGenderFilter, newValue);
  const updateCAdsetsSearchQuery = (newValueString) => (cAdsetsSearchQuery.value = newValueString);

  return {
    updateCAdsetsStatusFilter,
    updateCAdsetsGenderFilter,
    updateCAdsetsSearchQuery,
    updateCCampaignStatusFilter,
  };
};
